import { AnyAction } from 'redux'
import { FolioErrorOrder } from '../../../component/RoomCharge/types'
import {
	SET_FOLIO_ERROR_IS_LOADING, SET_FOLIO_ERROR_IS_RETRYING, SET_FOLIO_ERROR_MODAL_IS_OPEN, SET_FOLIO_ERROR_ORDERS,
} from '../../actionTypes/folioError'

export interface FolioErrorState {
	orders: FolioErrorOrder[]
	isLoading: boolean
	isRetrying: boolean
	modalIsOpen: boolean
}

const initialState: FolioErrorState = {
	orders: [],
	isLoading: false,
	isRetrying: false,
	modalIsOpen: false,
}

export function folioErrorReducer (state = initialState, action: AnyAction): FolioErrorState {
	switch (action.type) {
		case SET_FOLIO_ERROR_ORDERS:
			return { ...state, orders: action.value }
		case SET_FOLIO_ERROR_IS_LOADING:
			return { ...state, isLoading: action.value }
		case SET_FOLIO_ERROR_IS_RETRYING:
			return { ...state, isRetrying: action.value }
		case SET_FOLIO_ERROR_MODAL_IS_OPEN:
			return { ...state, modalIsOpen: action.value }
		default:
			return state
	}
}
